import { PlanTypes, CommonTypes } from "../../../interfaces";
import { axios } from "../../../lib/axios";
import { API_ROUTES } from "../../../lib/constants";
import { CMSTypes } from "../../../interfaces";
import { axiosupload } from "../../../lib/axiosupload";
// import axios from "axios";

interface SendESIMEmailPayload {
  firstName: string;
  
  email: string;
  qrImageUrl: string;
  iccid: string;
  dataAmount: number;
  duration: number;
  planName: string;
  countryName: string;
  couponId: string;
}

export const sendManualESIMEmail = async (data: SendESIMEmailPayload) => {
  const response = await axios.post("/admin/send-manual-esim-email", data);
  return response.data;
};

export const uploadImage = async (formData: FormData) => {
  const headers = {
    'Content-Type': 'multipart/form-data',
  };
  return axios.post(`/common/upload`, formData, { headers });
};
export const uploadOgImage = async (formData: FormData) => {
  const headers = {
    'Content-Type': 'multipart/form-data',
    'x-api-key': process.env.REACT_APP_UPLOAD_API_KEY
  };
  return axiosupload.post(`/api/upload`, formData, { headers });
};

export const getPartnerSubmissions = (query: any): Promise<any> => {
  return axios.get(`${API_ROUTES.DEEPLINK.GET_PARTNER_SUBMISSIONS}`, { params: query });
};

export const getCouponSubmissions = (query: any): Promise<any> => {
  return axios.get(`${API_ROUTES.DEEPLINK.GET_COUPON_SUBMISSIONS}`, { params: query });
};

export const listCountries = (params: { limit: number }) => {
  return axios.get(API_ROUTES.COUNTRIES.LIST, { params });
};

export const exportCouponClaims = (query: any): Promise<any> => {
  return axios.get(`${API_ROUTES.DEEPLINK.EXPORT_COUPON_CLAIMS}`, { 
    params: query,
    responseType: 'text',
    transformResponse: [(data) => {
      // Return the raw data without any transformation
      return data;
    }],
    headers: {
      'Accept': 'text/csv'
    }
  });
};

export const exportPartnerSubmissions = (query: any): Promise<any> => {
  return axios.get(`${API_ROUTES.DEEPLINK.EXPORT_PARTNER_SUBMISSIONS}`, { 
    params: query,
    responseType: 'text',
    transformResponse: [(data) => {
      return data;
    }],
    headers: {
      'Accept': 'text/csv'
    }
  });
};


